import { createUserManager } from 'redux-oidc';
import { auth } from '../config.{env}.json';

// Function to fetch the signing key from a remote server
async function fetchSigningKey() {
    const response = await fetch(auth.metadata.jwks_uri);
    if (!response.ok) {
        throw new Error('Failed to fetch the signing key');
    }
    const key = await response.json();
    
    // Check if key is an array return it
    if (Array.isArray(key)) {
        return key;
    }

    // Check if key.keys is an array return it
    if (Array.isArray(key.keys)) {
        return key.keys;
    }

    // If none of the above, throw an error
    throw new Error('Failed to fetch the signing key (Response is not an array)');
}

// Initialize userManager with the fetched key
async function initializeUserManager() {
    try {
        const signingKey = await fetchSigningKey();
        
        const userManagerConfig = {
            redirect_uri: window.location.origin,
            resource: 'restaurantcapabilitiesweb',
            response_type: 'token id_token',
            scope: 'openid profile',
            silent_redirect_uri: `${window.location.origin}/silent_renew.html`,
            automaticSilentRenew: true,
            filterProtocolClaims: true,
            loadUserInfo: false,
            ...auth,
            signingKeys: signingKey, // Add the fetched signing key here
        };

        const userManager = createUserManager(userManagerConfig);
        return userManager;
    } catch (error) {
        console.error('Error initializing userManager:', error);
    }
}

const userManagerPromise = initializeUserManager();

export { userManagerPromise };



// WEBPACK FOOTER //
// /src/oidc/userManager.js